import React, { Component } from 'react';
import { connect } from 'react-redux';
import Username from '../common/Username';
import { Row, Col, OverlayTrigger, Tooltip, Button } from 'react-bootstrap';
import Moment from 'react-moment';
import { toArray } from '../common/util';
import {hasPermission} from "../common/permissions";
import { pollSelector, pollItemSelector, chapterSelector, recruitmentSelector } from '../redux/selectors';
import { fetchPolls, postPoll, fetchUserApplications, postVote } from '../redux/actions';
import { ResponsiveContainer, RadialBarChart, RadialBar } from 'recharts';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faThumbsUp, faThumbsDown } from '@fortawesome/free-solid-svg-icons';

class RecruitmentItem extends Component {
    componentDidMount() {
        this.props.getPolls(this.props.users[this.props.recruit.member])
        this.props.getApplications(this.props.users[this.props.recruit.member].slug)
    }

    createPoll(user) {
        this.props.createPoll(user, user.displayName+'s Recruitment Poll')
    }

    vote(poll, item) {
        this.props.createVote(poll, item)
    }

    render() {
        let chartData = []
        if (toArray(this.props.polls.data).filter((poll) => poll.user === this.props.recruit.member).length > 0) {
            toArray(this.props.pollItems.data)
                .filter((item) => item.poll === toArray(this.props.polls.data).filter((poll) => poll.user === this.props.recruit.member)[0].id)
                .sort((a, b) => b.id - a.id)
                .map((item) => {
                    chartData.push({
                        "name": item.answer,
                        "uv": item.voteCount,
                        "pv": 5,
                        "fill": '#'+item.color,
                    })
                    return null;
                })
        }
        
        return (
            <div className="panel-adt" key={`${this.props.recruit.member}-recruit`}>
                <Row>
                    <Col md={8}>
                        <Row>
                            <Col md={4}>
                                <Username user={this.props.users[this.props.recruit.member]} rank={this.props.ranks[this.props.users[this.props.recruit.member].rank]} />
                                { toArray(this.props.recruitment.applications)
                                .filter((application) => application.user === this.props.recruit.member)
                                .map((application) => (
                                    <div>
                                        <Link to={"/recruitment/applications/"+application.id}>View {this.props.users[application.user].displayName}'s {this.props.chapters[application.chapter].game.title} application</Link>
                                    </div>
                                ))}
                            </Col>
                            <Col md={4}>
                                <span className="timestamp">
                                    <OverlayTrigger placement="top" overlay={<Tooltip id="created-tooltip"><Moment format="ddd MMM D YYYY">{this.props.recruit.joinDate}</Moment></Tooltip>}>
                                        <Moment fromNow>{this.props.recruit.joinDate}</Moment>
                                    </OverlayTrigger>
                                </span>
                            </Col>
                        </Row>
                    </Col>
                    <Col md={4}>
                        <div className="pull-right clearfix" style={{ margin:"-10px"}}>
                            { toArray(this.props.polls.data).filter((poll) => poll.user === this.props.recruit.member).length > 0 ? (
                                <div className="clearfix">
                                    <div className="pull-right">
                                        { toArray(this.props.pollItems.data)
                                            .filter((item) => item.poll === toArray(this.props.polls.data).filter((poll) => poll.user === this.props.recruit.member)[0].id)
                                            .map((item) => (
                                                <a style={{padding:"5px", cursor:"pointer", display:"block"}} onClick={() => this.vote(this.props.polls.data[item.poll], item)}><FontAwesomeIcon style={{color:"#"+item.color}} icon={(item.answer === "Yes") ? faThumbsUp : faThumbsDown} fixedWidth /> {item.answer}</a>
                                            ))
                                        }
                                    </div>
                                    <div className="pull-right">
                                    <ResponsiveContainer width={61} height={61}>
                                        <RadialBarChart
                                            margin={{ top: 0, right: 0, left: 0, bottom: 0 }}
                                            innerRadius="70%" 
                                            outerRadius="100%" 
                                            data={chartData}
                                            startAngle={0} 
                                            endAngle={360}
                                            >
                                            <RadialBar minAngle={15} label background={{ fill: '#333' }} isAnimationActive={true} dataKey='uv' />                                            
                                        </RadialBarChart>
                                    </ResponsiveContainer>
                                    </div>
                                </div>
                            ) : ( 
                                <div>
                                    { hasPermission('polls.add_poll', this.props.auth.permissions) ? ( 
                                        <div>
                                            <Button onClick={() => this.createPoll(this.props.users[this.props.recruit.member])}>
                                                Create Membership Poll
                                            </Button>
                                        </div>
                                        ) : null
                                    }
                                </div>
                            )}
                        </div>
                    </Col>
                </Row>
            </div>
        )        
    }
}

const mapStateToProps = (state) => ({
    chapters: chapterSelector(state),
    recruitment: recruitmentSelector(state),
    polls: pollSelector(state),
    pollItems: pollItemSelector(state),
});

const mapDispatchToProps = (dispatch) => ({
    getPolls: (member) => dispatch(fetchPolls(member)),
    getApplications: (member) => dispatch(fetchUserApplications(member)),
    createPoll: (member, title) => dispatch(postPoll(member, title)),
    createVote: (poll, item) => dispatch(postVote(poll, item)),
});

export default connect(mapStateToProps, mapDispatchToProps)(RecruitmentItem);


// WEBPACK FOOTER //
// ./src/Recruitment/RecruitItem.js